var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactBoxWrap"},[_c('div',{staticClass:"midSvg"},[_c('IconBase',{attrs:{"viewBox":'0 0 24 24'}},[_c('telephone')],1)],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"midDesWrap"},[_c('a',{attrs:{"href":"tel:88006009990"}},[_vm._v("8 800 600 99 90")]),_c('p',[_vm._v("звонок бесплатный по РФ")])])
}]

export { render, staticRenderFns }